// import DateUtils from "@date-io/date-fns";
import 'moment/locale/th'
import {
  getDate,
  getYear,
  getHours,
  getMinutes,
  getSeconds,
  getTime,
  format,
  parse,
} from 'date-fns'

import {} from 'date-fns/format'
import DateUtils from '@date-io/date-fns'

const BUDDHIST_YEAR_OFFSET = 543
const formatBuddhistDate = (date, formatString, locale) =>
  format(date, formatString, { locale }).replace(
    /\d{4}$/,
    String(getYear(date) + BUDDHIST_YEAR_OFFSET),
  )

export default class OverwriteFnsBE extends DateUtils {
  constructor({ locale, formats, instance }) {
    super({ locale, formats, instance })
  }

  format = (date, formatKey) => {
    switch (formatKey) {
      case 'year':
        return getYear(date) + BUDDHIST_YEAR_OFFSET
      case 'dayOfMonth':
        return getDate(date)
      case 'monthShort':
        return format(date, 'LLLL', { locale: this.locale })
      case 'month':
        return format(date, 'LLLL', { locale: this.locale })
      case 'fullDate':
        return formatBuddhistDate(date, 'dd/MM/yyyy', this.locale)
      case 'monthAndYear':
        return formatBuddhistDate(date, 'LLLL yyyy', this.locale)
      case 'time':
        return getTime(date)
      case 'hours':
        return getHours(date)
      case 'minutes':
        return getMinutes(date)
      case 'seconds':
        return getSeconds(date)
      default:
        return ''
    }
  }

  formatByString = (date, formatString) => {
    return formatString === this.formats.keyboardDate
      ? formatBuddhistDate(date, formatString, this.locale)
      : format(date, formatString, { locale: this.locale })
  }

  parse = (value, formatString) => {
    if (value === '') return null

    const input =
      formatString === this.formats.keyboardDate
        ? value.replace(/\d{4}$/, (year) =>
            String(Number(year) - BUDDHIST_YEAR_OFFSET),
          )
        : value

    return parse(input, formatString, new Date(), { locale: this.locale })
  }
}
